// Type mappings for field types
export const FIELD_TYPE_MAP: Record<string, string> = {
  // Internal types to display names
  string: 'Text',
  number: 'Number',
  boolean: 'Checkbox',
  date: 'Date',
  location: 'Location',
  attachment: 'Attachment',
  currency: 'Currency',
  rating: 'Rating',
  singleSelect: 'Single-select',
  multiSelect: 'Multi-select',
  email: 'Email',
  phone: 'Phone',
  percentage: 'Percentage',
  url: 'Url',
  'smart-fill': 'Smart fill',
  'web-search': 'Web search',
  translate: 'Translate',
}

// Display names to internal types
export const DISPLAY_TYPE_MAP: Record<string, string> = {
  Text: 'string',
  Number: 'number',
  Checkbox: 'boolean',
  Date: 'date',
  Location: 'location',
  Attachment: 'attachment',
  Currency: 'currency',
  Rating: 'rating',
  'Single-select': 'singleSelect',
  'Multi-select': 'multiSelect',
  Email: 'email',
  Phone: 'phone',
  Percentage: 'percentage',
  Url: 'url',
  'Smart fill': 'smart-fill',
  'Web search': 'web-search',
  Translate: 'translate',
}

// Utility functions
export const getDisplayType = (type: string): string => {
  return FIELD_TYPE_MAP[type] || 'Text'
}

export const getInternalType = (displayType: string): string => {
  return DISPLAY_TYPE_MAP[displayType] || 'string'
}
